/* eslint-disable */
const ROOT = '';

const Proxy = '/api';
const sportsProxy = '/sport/';

const HOMEBEFORE = {
  init: ROOT +  Proxy + '/init', // 获取所有banner列表
  BANNERLIST: ROOT +  Proxy + '/guest/bannerList', // 获取所有banner列表
  FIRSTNAVLIST: ROOT +  Proxy + '/guest/firstNavList', // 获取所有一级导航
  GAMELIST: ROOT +  Proxy + '/guest/gameList', // 获取最热游戏列表
  GETGAMEPLATFORM: ROOT +  Proxy + '/guest/getGamePlatform', // 获取所有的老虎机游戏平台名称列表
  GETSLOTGAMEPLATFORM: ROOT +  Proxy + '/guest/getSlotGameByPlatform', //根据游戏平台代码，获取游戏列表
  INDEXFOOT: ROOT +  Proxy + '/guest/indexFoot', // PC端获取页脚信息
  INDEXOFFER: ROOT +  Proxy + '/guest/indexOffer', // 获取首页优惠列表
  NAVLISTBYPARENTID: ROOT +  Proxy + '/guest/navListByParentId', // 获取非一级导航
  PUSHINFOLIST: ROOT +  Proxy + '/guest/pushInfoList', // 根据条件获取需要推送的信息
  serverInfo: ROOT +  Proxy + '/guest/serverInfo', // 游客获取服务器信息
  allGameInfo: ROOT +  Proxy + '/guest/allGameInfo', // 所有游戏平台
  platformPicInfo:ROOT +  Proxy + '/guest/platformPicInfo', // 获取所有平台图片
  floatPicList:ROOT +  Proxy + '/guest/floatPicList', // 获取所有挂件
  service:ROOT +  Proxy + '/guest/init', // 获取客服链接
  queryIndexOfferList:ROOT +  Proxy + '/guest/indexOffer/queryIndexOfferList', // 首页优惠导航
  fetchImgs:ROOT +  Proxy + '/guest/fetchImgs', // 根据Code获取配置图片
  fetchImg:ROOT +  Proxy + '/guest/fetchImg', // 根据Code获取配置图片
  getGoodVideo:ROOT +  Proxy + '/guest/leaderboard/getGoodVedio', // 获取工艺视频
  getVipInfoLis:ROOT +  Proxy + '/guest/vipinfo/showVIpInfo', // 获取VIP数据
  getCustomizeMatch: ROOT +  Proxy + '/guest/getCustomizeMatch',  // 获取365体育信息
  getMatchByPlatformCode: ROOT +  Proxy + '/guest/getMatchByPlatformCode',  // 印度获取365体育信息
  getRegisterList: ROOT +  Proxy + '/guest/queryRegisterItem', // 自定义注册项
};
const HOMEAFTER = {
  queryAgentBonus: ROOT +  Proxy + '/register/queryAgentBonus', // 获取注册用户是否为代理注册
  DEVIVEINFO: ROOT +  Proxy + '/loged/deviceInfo', // 获取用户设备信息
  logedUserInfo: ROOT +  Proxy + '/loged/logedUserInfo', // 返回所有登陆后一级页面需要的用户信息
  refreshUserInfo: ROOT +  Proxy + '/loged/refreshUserInfo', // PC端首页顶部刷新按钮
  refresh: ROOT +  Proxy + '/loged/refresh', // 检测登录状态
  queryUserLockAmount: ROOT +  Proxy + '/loged/queryUserLockAmount', // 查询会员账户锁定金额记录
  selfUnlockAmount: ROOT +  Proxy + '/loged/selfUnlockAmount', // 会员自助解锁锁定金额
  getminLimit: ROOT +  Proxy + '/loged/minLimit', // 最低取款额
  getusdtRate: ROOT + Proxy + '/loged/usdtRate', // USDT汇率
  getfrontconfig: ROOT +  Proxy + '/guest/frontConfig/getFrontConfig', // 365代理联系方式
  getFrontConfigList: ROOT +  Proxy + '/guest/frontConfig/getFrontConfig/list', // 365所有代理联系方式
};
const USER = {
  REGISTER: ROOT +  Proxy + '/guest/registered', // 注册
  REGISTERPHONE: ROOT +  Proxy + '/guest/registeredphone', //  新注册页接口
  registeredNew: ROOT +  Proxy + '/guest/registeredNew', // (多彩宝)注册
  REGISTERCODE: ROOT +  Proxy + '/guest/defaultKaptcha',// 验证码
  LOGIN: ROOT +  Proxy + '/login', // 登陆
  THIRAUTHLOGIN:ROOT +  Proxy + '/guest/thirAuthLogin',   //第三方登录
  FIRSTUSERINFO: ROOT +  Proxy + '/loged/firstUserInfo', // 首次登陆信息
  LOGINOUT: ROOT +  Proxy + '/loged/logout', // 登出
  MYCOLLECTION: ROOT +  Proxy + '/loged/myCollection', // 我的收藏
  LASTSCAN: ROOT +  Proxy + '/loged/lastScan',  // 最近浏览过的游戏
  updateLoginPassword: ROOT +  Proxy + '/loged/updateLoginPassword',  // 更改登陆密码
  confirm: ROOT +  Proxy + '/guest/forget/confirm',  // 忘记密码功能：第二步，输入账号、手机/邮箱，加类型，验证码，密码，确认密码
  sendCode: ROOT +  Proxy + '/guest/forget/sendCode',  // 忘记密码功能：第一步，输入账号、手机/邮箱，加类型，发送验证码
  sendCodeNew: ROOT +  Proxy + '/guest/forget/sendCodeNew',  // (多彩宝) 忘记密码功能：第一步，输入账号、手机/邮箱，加类型，发送验证码
  forgetPassword: ROOT +  Proxy + '/guest/forgetPassword',  // 忘记密码功能：请预留正确的联系方式客服会在1天内主动联系，或者直接联系客服
  sendVerifictionCode: ROOT +  Proxy + '/guest/lottery/login/sendVerifictionCode' //手机验证码登录
};

const GAME = {
  gamePlatform: ROOT +  Proxy + '/game/guest/gamePlatform',  // 获取游戏类型列表
  heatGamePlatform: ROOT + Proxy + '/game/guest/heatGamePlatform', //获取热门
  topFlowData: ROOT +  Proxy + '/logged/topFlowData',  // 获取今日流水
  searchResult: ROOT +  Proxy + '/guest/searchResult',  // 搜索

  allGame: ROOT +  Proxy + '/game/guest/allGame',  // 平台全部游戏（棋牌等..）
  newGame: ROOT +  Proxy + '/game/guest/newGame',  // 平台最新游戏（棋牌等..）
  hotGame: ROOT +  Proxy + '/game/guest/hotGame',  // 平台热门游戏（棋牌等..）
  queryAllGameList:  ROOT +  Proxy + '/game/guest/queryAllGameList',  //牛牛
  newHeatGamePlatform:  ROOT +  Proxy + '/game/guest/newHeatGamePlatform',  //热门游戏

};

// slot-controller 老虎机的首页接口
const SLOT = {
  slotBanner: ROOT +  Proxy + '/guest/slotBanner',// 老虎机banner
  slotOffer: ROOT +  Proxy + '/guest/slotOffer',// 老虎机相关优惠
  slotRank: ROOT +  Proxy + '/guest/slotRank',// 老虎机压码排行
  totalSlot: ROOT +  Proxy + '/guest/totalSlot',// 老虎机全部游戏
  maybeLike: ROOT +  Proxy + '/logged/maybeLike',// 可能喜欢
  mySlot: ROOT +  Proxy + '/logged/mySlot',// 我的游戏列表
  addCollection: ROOT +  Proxy + '/logged/addCollection',// 添加游戏至我的收藏
  cancelCollection: ROOT +  Proxy + '/logged/cancelCollection',// 取消收藏
  selectGameSlotType: ROOT +  Proxy + '/guest/selectGameSlotType',// 老虎机游戏

  // 印度收藏接口如下 
  InaddCollection: ROOT +  Proxy + '/game/logged/addCollection', // 添加游戏至我的收藏  
  IncancelCollection: ROOT +  Proxy + '/game/logged/cancelCollection',// 取消收藏   
  InselectUserCollectionList:ROOT + Proxy + '/game/logged/selectUserCollectionList', // 查看会员收藏
  InCollectionListIds:ROOT + Proxy + '/game/logged/selectUserCollectionListIds', // 查询会员收藏列表,只返回收藏id
  InGamePlatformGroup:ROOT + Proxy + '/game/guest/gamePlatformGroup', // 首页除热门其他游戏 hot 接口

};
// 板球
const Cicket ={
  matchesAllMatches:ROOT + Proxy + '/guest/matches/allMatches', // 所有赛事
  getbettingList:ROOT + Proxy + '/loged/bet/bettingListIOS', // 投注
  getMatchesInfo:ROOT + Proxy + '/guest/matches/getMatchesInfoBySeason', // 所有赛事详情
  getMyBets:ROOT + Proxy + '/loged/bet/getBets', // 我的注单列表
  
  // 个人中心任务列表
  getTaskList:ROOT + Proxy + '/guest/getTaskList', // 获取任务列表
  getTaskPrize:ROOT + Proxy + '/guest/getTaskPrize', // 获取任务奖励
  getHeadTaskList:ROOT + Proxy + '/guest/getHeadTaskList', // getHeadTaskList

};
// IPL
const IPL = {
  getGameOrder:ROOT + Proxy + '/guest/getGameOrder', // 获取我的记录
  getHeadBit:ROOT + Proxy + '/guest/getHeadBit', // 获取任务奖励
  getRank:ROOT + Proxy + '/guest/getRank', // rank
  getGameList:ROOT + Proxy + '/guest/getGameList', // 获取比赛列表
  gameBet:ROOT + Proxy + '/guest/gameBet', // 比赛投注
  getChampionQuiz:ROOT + Proxy + '/guest/getChampionQuiz', // 获取队伍列表
  championQuizBet:ROOT + Proxy + '/guest/championQuizBet', // 冠军竞猜
  getBetOrder:ROOT + Proxy + '/guest/getBetOrder', // 获取投注兑换记录
  getConfig:ROOT + Proxy + '/guest/getConfig', // 获取配置
  picToByte:ROOT + Proxy + '/guest/picToByte', // 图片转换
}
// 团队
const team ={
  queryBelongList:ROOT + Proxy + '/userPromote/queryBelongList', // 查询直属列表
  queryBelongTotalInfo:ROOT + Proxy + '/userPromote/queryBelongTotalInfo', // 查询直属成员总数
  queryTeamTotalInfo:ROOT + Proxy + '/userPromote/queryTeamTotalInfo', // 查询团队成员总数
  queryTeamList:ROOT + Proxy + '/userPromote/queryTeamList', // 查询团队成员列表
  queryMyTeamInfo:ROOT + Proxy + '/userPromote/queryMyTeamInfo', // 查询团我的团队信息
  withdrawMyPromoteAmount:ROOT + Proxy + '/userPromote/withdrawMyPromoteAmount', // 提取我的佣金
  queryMyPromoteGiftLogList:ROOT + Proxy + '/userPromote/queryMyPromoteGiftLogList', // 我的佣金记录
  queryMyDailyPromoteInfo:ROOT + Proxy + '/userPromote/queryMyDailyPromoteInfo', // 我的业绩信息
  queryPromoteLevelList:ROOT + Proxy + '/userPromote/queryPromoteLevelList', // 返佣比例
  queryDailyPromoteList:ROOT + Proxy + '/userPromote/queryDailyPromoteList', // 每日查询
  
}

const VIP = {
  VIPPRIVILEGE: ROOT +  Proxy + '/guest/vipPrivilege', // VIP特权
  CHECKIN: ROOT +  Proxy + '/loged/checkin', // 签到
  CHECKININFO: ROOT +  Proxy + '/loged/checkinInfo', // 签到的信息
  LOTTERY: ROOT +  Proxy + '/loged/lottery', // 签到抽奖
  inviteCode: ROOT +  Proxy + '/loged/inviteCode', // 生成邀请码
  inviteList: ROOT +  Proxy + '/loged/inviteList', // 生成邀请列表
  getInviteBonus: ROOT +  Proxy + '/loged/getInviteBonus', // 点击领取奖金按钮，领取奖金
  myBalanceList: ROOT +  Proxy + '/loged/myBalanceList', // 我的账单列表
  myOrderList: ROOT +  Proxy + '/loged/selectUserPayOrderList', // 会员存款订单列表查询
  balanceDetail: ROOT +  Proxy + '/loged/balanceDetail', // 账单详情
  getMsgSiteList: ROOT +  Proxy + '/loged/getMsgSiteList', // 站内信
  updateMsgSite: ROOT +  Proxy + '/loged/updateMsgSite', // 站内信状态
  deleteMsgSite: ROOT +  Proxy+ '/loged/deleteMsgSite', //删除站内信
  insertMsgSite: ROOT +  Proxy+ '/loged/insertMsgSite', //会员发送信息
  getVipReward: ROOT +  Proxy+ '/vipDeposit/getVipReward', // VIP等级优惠领取
};

const DISCOUNTS={
  OFFERBANNER: ROOT +  Proxy + '/guest/offerBanner', // 优惠板块的banner
  OFFERLIST: ROOT +  Proxy + '/guest/offerList', // 根据条件筛选
  OFFERTYPELIST: ROOT +  Proxy + '/guest/offerTypeList', // 获取优惠类型
  MYOFFER: ROOT +  Proxy + '/loged/myOffer', // 获取我的优惠列表
  queryBonusArticleTypeList:ROOT +  Proxy + '/guest/queryBonusArticleTypeList', // （新）获取优惠类型
  queryBonusArticleInfoList:ROOT +  Proxy + '/guest/queryBonusArticleInfoList', // （新）获取优惠列表
  querySelfApplyBonusList:ROOT +  Proxy + '/guest/querySelfApplyBonusList' , //活动大厅列表
  queryBonusArticleInfoDetail:ROOT +  Proxy + '/guest/queryBonusArticleInfoDetail',//活动大厅获取文章
  offerDetail: ROOT +  Proxy + '/guest/offerDetail', // 进入优惠详情
  relatedOffer: ROOT +  Proxy + '/guest/relatedOffer', // 获取游戏的相关优惠
  getrankList: ROOT + Proxy + '/guest/leaderboard/query',  //获取排行榜数据
  getrefresh: ROOT + Proxy + '/guest/leaderboard/refresh'  //获取排行榜数据
};
// money
const WALLET = {
  RECHARGE:ROOT +  Proxy + '/indexpay/webpay_gateway',
  withdrawList:ROOT +  Proxy + '/logged/withdrawList',
  refreshGameAccount:ROOT +  Proxy + '/logged/refreshGameAccount', // 账户刷新
  balance:ROOT +  Proxy + '/game/balance', //  获取平台余额
  gameHistory:ROOT +  Proxy + '/game/logged/gameHistory', //  获取投注记录
  newgameHistory:ROOT +  Proxy + '/game/logged/newGameHistory',
};

// 支付方式
const PAY = {
  addBankCard:ROOT +  Proxy + '/loged/addBankCard', // 添加银行卡
  deleteBank:ROOT +  Proxy + '/loged/deleteBank', // 删除银行卡
  bankCardList:ROOT +  Proxy + '/loged/bankCardList', // 获取银行卡列表
  checkBankCard:ROOT +  Proxy + '/loged/checkBankCard', // 验证银行卡信息
  payType:ROOT +  Proxy + '/loged/payType', // 获取支付类型
  reserveWithdrawConfig: ROOT + Proxy + '/loged/reserveWithdrawConfig', // 获取会员是否可见预约取款通道
  newPayType:ROOT +  Proxy + '/loged/payType/v2', // 获取新支付类型
  payConfig:ROOT+ Proxy + '/loged/payConfig/v2', // 获取支付的内容
  sendWithdrawYZM:ROOT +  Proxy + '/loged/sendWithdrawYZM', // 发送提款密码验证码 / 修改邮箱验证码
  setWithdrawPW:ROOT +  Proxy + '/loged/setWithdrawPW', // 设置提款密码
  updateWithdrawPW:ROOT +  Proxy + '/loged/updateWithdrawPW', // 修改提款密码
  applyWithdraw:ROOT +  Proxy + '/loged/applyWithdraw', // 申请提现
  deposit:ROOT +  Proxy + '/loged/deposit', // 向游戏平台转账
  withdraw:ROOT +  Proxy + '/loged/withdraw', // 向中心钱包转账
  getAllPlatform:ROOT +  Proxy + '/loged/getAllPlatform', // 获取所有平台
  withdrawGames:ROOT +  Proxy + '/loged/withdrawGames', // 取出全部的金额，用于提现等页面
  uploadFile:ROOT +  Proxy + '/uploadFile', //图片上传
  inPayOrder:ROOT +  Proxy + '/bankpay/inPayOrder', //印度存款
  inPayUSDTOrder:ROOT +  Proxy + '/bankpay/inPayUSDTOrder', //印度USDT存款
  indepositOrderlist:ROOT +  Proxy + '/logged/depositOrder/list', //印度存款列表
  incancelOrder:ROOT +  Proxy + '/logged/cancelOrder', //印度取消订单
  inBanks:ROOT +  Proxy + '/logged/inBanks/list', //获取印度银行卡列表
  addUSDTAddress: ROOT +  Proxy + '/loged/addUSDTAddress', // 绑定USDT地址
  DJS:ROOT +  Proxy + '/logged/deposit/djs', //获取倒计时  payExpirationTimeOnlne.  线上倒计时，如果为空没有 payExpirationTime 公司入款倒计时
  offlineAuto:ROOT +  Proxy + '/offlineAuto/payOrder', //自动上分
  autoBanks:ROOT +  Proxy + '/logged/autoBanks/list', //自动上分银行卡列表
  semiAutomatic: ROOT +  Proxy + '/semiAutomatic/payOrder', // 半自动上分
};
// 帮助/关于我们板块接口
const HELP = {
  articleById:ROOT +  Proxy + '/guest/articleById', // 根据文章id获取文章
  articleListByType:ROOT +  Proxy + '/guest/articleListByType', // 根据文章类型获取文章列表
  articleType:ROOT +  Proxy + '/guest/articleType', // 获取文章类型
  pushInfo:ROOT +  Proxy + '/guest/pushInfo', // 获取当前时间的推送通知-未登陆状态
  logedPushInfo:ROOT +  Proxy +'/loged/pushInfo', // 获取所有推送和通知-已登陆状态
};

// 认证
const CONFIRM ={
  confirmEmail:ROOT +  Proxy + '/loged/confirmEmail', // 邮箱认证
  submitEmail:ROOT +  Proxy + '/loged/submitEmail ', // 邮箱认证 只需要提交邮箱
  confirmQQ:ROOT +  Proxy + '/loged/confirmQQ', //  QQ认证
  confirmWeChat:ROOT +  Proxy + '/loged/confirmWeChat', //  微信认证
  confirmPhone:ROOT +  Proxy + '/loged/confirmPhone', // 手机验证
  confirmRealName:ROOT +  Proxy + '/loged/confirmRealName', // 实名认证接口
  email:ROOT +  Proxy + '/loged/email', // 发送邮箱验证
  sendPhone:ROOT +  Proxy + '/loged/sendPhone', // 发送手机验证码
  updateEmail:ROOT +  Proxy + '/loged/updateEmail', // 修改邮箱

  queryCountryList:ROOT +  Proxy + '/guest/search/queryCountryList', // 获取电话国家列表
  sendPhoneSMS:ROOT +  Proxy + '/loged/sendPhoneSMS', // 发送验证码
  sendVerify:ROOT +  Proxy + '/guest/phone/sendVerify', // 注册页面发送验证码


  // confirmQQ:ROOT +  Proxy + '/loged/confirmQQ', // 发送验证码
  // confirmWeChat:ROOT +  Proxy + '/loged/confirmWeChat',  // 发送验证码
  
  submitBirthDay:ROOT +  Proxy + '/vipDeposit/submitBirthDay'  // 绑定生日
};
//签到
const SIGN = {
  checkIntegralConfigList: ROOT + Proxy +'/loged/checkIntegralConfigList', //签到可以获得奖励列表
  getUserIntegral:ROOT +  Proxy + '/loged/getUserIntegral', //获取用户当前积分信息
  getUserCheckInfo:ROOT +  Proxy + '/loged/getUserCheckInfo',//获取用户当前签到信息
  userCkeckIn:ROOT +  Proxy + '/loged/userCheckIn', //用户点击签到
  checkInHistory:ROOT +  Proxy +'/loged/checkInHistory',//签到历史
  //积分
  bonusExchangeConfigList:ROOT + Proxy +'/loged/bonusExchangeConfigList', //兑换可以获得奖励列表
  bonusIntegralExchange:ROOT +Proxy +'/loged/bonusIntegralExchange' , //兑换积分
  bonusExchangeHistory:ROOT +Proxy +'/loged/bonusExchangeHistory'  //兑换积分记录
}
// 红利
const DEPOSIT ={
  showIndexInfo:ROOT +  Proxy + '/deposit/showIndexInfo', // 首页展示信息 - 存款红利
  showPrizeInfo:ROOT +  Proxy + '/deposit/showPrizeInfo', // 进入抽奖页面，获取奖品展示的接口，如果没有那么展示静态奖品
  clickButton:ROOT +  Proxy + '/deposit/clickButton', // 点击抽奖按钮
  applyBonus:ROOT +  Proxy + '/deposit/applyBonus', // 申请存款红利
  vipapplyBonus:ROOT +  Proxy + '/vipDeposit/getVipReward', // 申请VIP红利
  otherApplyBonus:ROOT +  Proxy + '/other/applyBonus', // 申请其他红利

  applyBetBonus:ROOT +  Proxy + '/applyBonus/applyBetBonus', // 申请投注优惠
  getRealTimeAmount:ROOT +  Proxy + '/guest/getRealTimeAmount', // 领取时时流水
  getuserAgentBonus:ROOT +  Proxy + '/loged/userAgentBonus', // 领取时时流水  手动审核
  applyPrivateCustomBonus:ROOT +  Proxy + '/applyBonus/applyPrivateCustomBonus', // 领取客制活动
  realTimeAmount:ROOT +  Proxy + '/guest/realTimeAmount', // 查看时时流水
  queryBonusBindUserInfoList:ROOT +  Proxy + '/guest/queryBonusBindUserInfoList', // 查询会员绑定优惠

  receiveMyBonus:ROOT +  Proxy + '/loged/receiveMyBonus', // 红利领取中心领取红利

  selectUserUpgradeInfo:ROOT +  Proxy + '/deposit/selectUserUpgradeInfo', // 查询会员绑定优惠

  queryTurntableRaffle:ROOT +  Proxy + '/activity/guest/queryRaffle', // 大转盘抽奖 未登录
  raffle:ROOT +  Proxy + '/activity/raffle', // 大转盘抽奖 已登录
  queryHistoryWin:ROOT +  Proxy + '/activity/queryHistoryWin', // 大转轮历史记录
  queryNewWin:ROOT +  Proxy + '/activity/queryNewWin', // 小游戏最新中奖记录查询
  realTimeAmountAll:ROOT +  Proxy + '/guest/realTimeAmountAll', // 获取所有可领取的时时流水金额
  getRealTimeAmountAll:ROOT +  Proxy + '/guest/getRealTimeAmountAll', // 领取所有可领取的时时流水金额
  realTimeRecord:ROOT +  Proxy + '/guest/realTimeRecord', // 获取流水优惠记录
  // 余额宝
  availableYEBList:ROOT +  Proxy + '/applyBonus/selectBonusBalanceProfitList', // 查询可购买的余额宝列表
  purchasedYEBList:ROOT +  Proxy + '/applyBonus/queryUserBuyBalanceProfitList', // 查询已购买的余额宝列表
  buyYEBProgram:ROOT +  Proxy + '/applyBonus/buyBalanceProfit', // 购买余额宝
  ransomYEBProgram:ROOT +  Proxy + '/applyBonus/ransomBalanceProfit', // 赎回余额宝
  getVipRewardGift:ROOT +  Proxy + '/vipDeposit/getVipRewardGift', // VIP页面领取接口  1晋升礼金2生日礼金3节日礼金
  fastApplyPromotion:ROOT +  Proxy + '/vipDeposit/fastApplyPromotion', // VIP快速晋级申请

  // 红绿灯彩票
  LotteryInit:ROOT +  Proxy + '/guest/gtLottery/init', // 获取红绿灯彩票信息初始化
  
  // 单条投注 红绿灯彩票下注{"period"="开奖期数","betAmount"="下注金额","betNum"="下注号码,多个下注号码用,隔开"}
  bettingGt:ROOT +  Proxy + '/guest/gtLottery/bettingGt',
  
  // 红绿灯彩票多条下注：
  // [{"period":"开奖期数","betAmount":"下注金额","betNum":"下注号码,多个下注号码用,隔开"},{"period":"开奖期数","betAmount":"下注金额","betNum":"下注号码,多个下注号码用,隔开"}]
  batchBettingGt:ROOT +  Proxy + '/guest/gtLottery/bettingList',

  getDrawLotteryList:ROOT +  Proxy + '/guest/gtLottery/getResultList', // 获取红绿灯彩票的开奖记录
  getUserDrawLotteryList:ROOT +  Proxy + '/guest/gtLottery/userBetRecords', // 获取红绿灯彩票注单记录
};

// 体育
const SPORT = {
  sport: ROOT +  sportsProxy  // 首页数据
}
/**
 * 威尼斯 */
const agency_register = ''  //代理注册：
const agency_login = ''  //代理登入：

// 代理网址
const agentUrl = '';
// 线路网址
const loadUrl = '';
// 下载地址
const downloadPC = '';
// 客服
const service = '';

/**
 * 多彩宝 */
// 代理网址
// const color_Agent_Url = 'https://affiliate.docobo88.com/#agent/register';
const color_Agent_Url = '';


/**
 * 金色版 */
const gold_Agent_Url = '';
const gold_service_Url = '';
const gold_app_download = '';

/**
 * 太阳城
 * */
const sun_loadUrl = '';
const sun_service = '';
const sun_agentUrl = '';

/**
 *  build07
 * */
const sands2_loadUrl = '';
const sands2_downloadPC = '';
const sands2_service = '';
const sands2_agentUrl = '';

/**
 * 金沙新 9750*/
const newSands_agentUrl = '';
const newSands_agentUrl_login = '';


/**
 * 威尼斯 2668*/


/**
 * 365 */


/**
 * 乐赢 */
const ly_agentUrl = ''
const ly_registerAgentUrl = ''
const ly_detectionUrl = ''

export default {
  HOMEBEFORE: HOMEBEFORE,
  HOMEAFTER: HOMEAFTER,
  DISCOUNTS: DISCOUNTS,
  USER: USER,
  SLOT: SLOT,
  Cicket:Cicket,
  WALLET: WALLET,
  IPL,
  team:team,
  VIP,
  PAY,
  HELP,
  CONFIRM,
  GAME,
  DEPOSIT,
  SPORT,
  SIGN,
  color_Agent_Url,

  agency_register,
  agency_login,
  service,
  downloadPC,
  agentUrl,
  loadUrl,
  sun_loadUrl,
  sun_service,
  sun_agentUrl,

  gold_service_Url,
  gold_app_download,
  gold_Agent_Url,

  sands2_loadUrl,
  sands2_service,
  sands2_agentUrl,
  sands2_downloadPC,

  newSands_agentUrl,
  newSands_agentUrl_login,

  // loadUrl_2668,
  // agentUrl_2668,

  // agentUrl_365,
  // hijack_365,

  ly_agentUrl,
  ly_registerAgentUrl,
  ly_detectionUrl
}



// WEBPACK FOOTER //
// ./src/common/urls/url.js